import http from '@/utils/http'
import config from '@/config/config'

const api = {
  getRule: config.eventRoot + '/market-register/spread/getChannelRewardInfo',
  getRewardStatus: config.eventRoot + '/market-register/spread/isGetReward',
  getReward: config.eventRoot + '/market-register/spread/getReward',
  getChannelRewardList: config.eventRoot + '/market-register/spread/getChannelRewardList'
}

export function getRule (rewardId) {
  return http.get(api.getRule, { reward_id: rewardId })
}

export function getRewardStatus (channelId, userId) {
  return http.get(api.getRewardStatus, { channel_id: channelId, user_id: userId })
}

export function getReward (rewardId, userId, loginWay = 'weixin') {
  return http.get(api.getReward, { reward_id: rewardId, user_id: userId, login_way: loginWay })
}

export function getChannelRewardList (channelId, userId) {
  return http.get(api.getChannelRewardList, { channel_id: channelId, user_id: userId })
}